import { Theme } from '@mui/material';
import  Box  from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { SxProps } from '@mui/system';
import React, { PropsWithChildren } from 'react';

interface ModalProps extends PropsWithChildren {
  isOpen: boolean;
  handleClose: () => void;
}

const style: SxProps<Theme>= {
  position: 'absolute' ,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100vw',
  height: '100vh',
  bgcolor: 'black',
  boxShadow: 24,
  p: 4,
};

const CustomModal: React.FC<ModalProps> = ({ isOpen, handleClose, children }) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
          {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
